export const fileToRawBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      const rawBase64 = base64.split(",")[1];
      resolve(rawBase64);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};